/*
 * @module expression
 * Dynmaic Inline Expressson (DIE)
 */

define('shared/util/dom/expression',['$' , 
    './expression/TextSearcher', 
    './expression/AttrSearcher', 
    './expression/Evaluator', 
    'shared/util/registers/DataProvider',
    'shared/lib/RSVP',
    'shared/lib/console'
], 
function ($, TextSearcher, AttrSearcher, Evaluator, DataProvider, RSVP, console) {
    'use strict';

    var KEY_DATA_EXPRESSION = 'expression';
    var KEY_EVENT_CHANGE = 'change';
    var RE_ESCAPE = /[-\/\\^$*+?.()|[\]{}]/g;
    var nodeHeap = [];
    
    function escape(s){
        RE_ESCAPE.lastIndex = 0;
        return s.replace(RE_ESCAPE, '\\$&');
    }

    function nodeHeapGet( node ) {
        for(var l = nodeHeap.length; l--;){
            if ( nodeHeap[l].node == node ) {
                return nodeHeap[l];
            }
        }

        return null;
    }

    function renderNode ( node ) {
        var die = nodeHeapGet(node);
        var temp = die.format;
        var key, value;

        console.group('shared/util/dom/expression: rendering');

        for ( key in die.keyValues ) {
            if ( !die.keyValues.hasOwnProperty(key) ) {
                continue;
            }

            value = die.keyValues[key];

            console.log('key: ', key, ', value: ', value);

            temp = temp.replace
            (
                new RegExp('\\$\\{' + escape(key) + '\\}', 'g'),
                value
            );  
        }

        console.groupEnd();
        
        if ( temp != node.nodeValue ) {
            node.nodeValue = temp;
        }
    }

    function hookFutureChanges(evaluator, key, node, data) {
        var dataProvider;
        var cleared = false;

        function handleClear(){
            if (cleared) {
                return;
            }

            for(var l = evaluator.providers.length; l--;) {
                dataProvider = evaluator.providers[l];
                dataProvider.off(KEY_EVENT_CHANGE, handleRedo);
            }

            cleared = true;
        }

        function handleRedo(){
            handleClear();
            evalUpdate.call(evaluator, key, node, data)
                .then(function(ev){
                    if (ev == null) {
                        return;
                    }
                    
                    return RSVP.resolve(ev);
                })
                .then(function(ev){
                    hookFutureChanges(ev, key, node, data);
                }, function(error){
                    hookFutureChanges(error.evaluator, key, node, data);
                });
        }

        for(var l = evaluator.providers.length; l--;) {
            dataProvider = evaluator.providers[l];
            dataProvider.on(KEY_EVENT_CHANGE, handleRedo);
        }

        data.garbages.push(handleClear);
    }

    function updateSearchResult( searcher, data ){
        function innerLoopHandler(key, node){
            evalUpdate(key, node, data)
                .then(function(ev){
                    if (ev == null) {
                        return;
                    }
                    
                    return RSVP.resolve(ev);
                })
                .then(function(ev){
                    hookFutureChanges(ev, key, node, data);
                }, function(error){
                    hookFutureChanges(error.evaluator, key, node, data);
                });
        }

        for(var i = 0; i < searcher.nodes.length; i++) {
            var cur = searcher.nodes[i];
            console.log('Found DIE expressson:', cur.keys);

            for(var j = 0; j < cur.keys.length; j++) {
                innerLoopHandler(cur.keys[j], cur);
            }
        }
    }

    function evalUpdate( key, nodeInfo, data ){
        var node = nodeInfo.node;
        var ev = this instanceof Evaluator?this:new Evaluator();

        return ev.evaluate( key )
            .then(function(value){

                if ( value == null ) {
                    console.warn('DIE Expression key cannot be found: ' + key);
                }

                var die = nodeHeapGet(node);

                if ( die == null ) {
                    die = {
                        node: node,
                        format: node.nodeValue,
                        keyValues: {}
                    };
                    nodeHeap.push(die);
                    data.garbages.push((function(ind){
                        return function(){
                            nodeHeap[ind].node = null;
                            delete nodeHeap[ind].node;
                            delete nodeHeap[ind];
                        };
                    })(nodeHeap.length - 1));
                }

                die.keyValues[key] = value + '';

                renderNode( node );

                return RSVP.resolve(ev);
            }, function(reason){
                console.error('Something went wrong while trying to evaluate the expression: ',
                    reason, 
                    '\nWill retry again when data changed...');
                return RSVP.reject({
                    evaluator: ev,
                    message: reason
                });
            });
    }

    function enable() {
        var $el = $(this);
        var data = $el.data(KEY_DATA_EXPRESSION);

        if ( data != null ) {
            // enabled already, skip
            return;
        }
        else {
            data = {
                garbages: []
            };
            $el.data(KEY_DATA_EXPRESSION, data);
        }

        var textSearcher = new TextSearcher($el);
        var attrSearcher = new AttrSearcher($el);

        textSearcher.search();
        attrSearcher.search();

        return RSVP.all([
            updateSearchResult(textSearcher, data),
            updateSearchResult(attrSearcher, data)
        ]);

    }

    function disable() {
        var $el = $(this);
        var data = $el.data(KEY_DATA_EXPRESSION);

        if ( data == null ) {
            return;
        }

        for(var l = data.garbages.length; l--;) {
            data.garbages[l]();
        }

        data.garbages = null;

        $el.removeData(KEY_DATA_EXPRESSION);
    }

    var ret = {
        /*
         * @function enable
         * @param {jQuery Object} Enable DIE on this element
         */
        enable: function( $el ) {
            var prms = [];

            $el = $el.add($el.find('*'));
            $el.each(function(){
                prms.push(enable.call(this));
            });

            return RSVP.all(prms);
        },
        /*
         * @function disable
         * @param {jQuery Object} Disable DIE on this element
         */
        disable: function( $el ){
            var prms = [];

            $el = $el.add($el.find('*'));
            $el.each(function(){
                prms.push(disable.call(this));
            });

            return RSVP.all(prms);
        }
    };

    return ret;
});
